import dayjs from "dayjs"

export const formatCurrencyCompact = (value) => {
  if (value === null || value === undefined) return "₦0";

  const num = Number(value);

  if (num >= 1_000_000_000) {
    const formatted = (num / 1_000_000_000).toFixed(3);
    return "₦" + (formatted.endsWith(".000") ? formatted.slice(0, -4) : formatted) + "B";
  }

  if (num >= 1_000_000) {
    const formatted = (num / 1_000_000).toFixed(3);
    return "₦" + (formatted.endsWith(".000") ? formatted.slice(0, -4) : formatted) + "M";
  }

  if (num >= 1_000) {
    const formatted = (num / 1_000).toFixed(3);
    return "₦" + (formatted.endsWith(".000") ? formatted.slice(0, -4) : formatted) + "K";
  }

  // For numbers < 1000, show up to 3 decimal places
  const formatted = num.toFixed(3);
  return "₦" + (formatted.endsWith(".000") ? formatted.slice(0, -4) : formatted);
};


export const formatCurrency = (value) => {
  if (!value) return "₦0.00"

  // Convert to string, remove commas
  const cleaned = String(value).replace(/,/g, '')

  const num = parseFloat(cleaned)

  if (isNaN(num)) return "₦0.00"

  return "₦" + num.toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const formatNumber = (value) => {
  return Number(value || 0).toLocaleString()
}

export const formatDate = (date) => dayjs(date).format("MMM DD, YYYY")

export const formatMonthlyData = (apiData) => {
    const result = new Array(12).fill(0)

    apiData?.forEach(item => {
        const date = new Date(item.month)
        const monthIndex = date.getMonth() // 0 = Jan

        result[monthIndex] = Number(item.total)
    })

    return result
}

export const formatDateTime = (date) => {
  if (!date) return ''

  const d = new Date(date)

  return `${d.getDate().toString().padStart(2, '0')} ${d.toLocaleString('en-NG', {
    month: 'short'
  })} ${d.getFullYear()} • ${d.toLocaleTimeString('en-NG', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })}`
}


export const formatTitle = (value) => {
  if (!value) return ''
  return value
    .toString()
    .replace(/_/g, ' ') // optional: convert "pay_in" → "pay in"
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

//risk
export const getRiskClass = (risk) => {
  if (risk === 'Low') return 'text-green'
  if (risk === 'Medium') return 'text-orange'
  return 'text-red'
}

//get errors
export const getAllErrors = (error) => {
  const data = error.response?.data

  if (!data?.errors) return data?.message || "Error"

  return Object.values(data.errors)
    .flat()
    .join("\n")
}

//capitalize
export const capitalize = (text) =>
  typeof text === 'string' && text.length
    ? text.charAt(0).toUpperCase() + text.slice(1)
    : ''

// const truncate = (text) => !text ? "" : text.length > 60 ? text.substring(0, 60) + "..." : text

//format html
export const truncateHtml = (html) => {
  if (!html) return ""

  const text = html.replace(/<[^>]*>/g, "") // strip tags for truncation
  const short = text.length > 60 ? text.substring(0, 60) + "..." : text

  return short
}

//display html
export const displayHtml = (html) => {
  if (!html) return ""

  const text = html.replace(/<[^>]*>/g, "") // strip tags for truncation

  return text
}

export const formatRole = (role) => {
  return role
    ?.split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
}
